import { useParams, Link } from "react-router-dom"

import { categories } from "../data/categories"
import { products } from "../data/products"

import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"
import ProductGrid from "../components/products/ProductGrid"

export default function CategoryDetails() {
  const { slug } = useParams()

  const category = categories.find(
    (item) => item.slug === slug
  )

  if (!category) {
    return (
      <section className="py-20">
        <div className="container mx-auto px-4 text-center">

          <h1 className="text-4xl font-bold text-gray-900">
            Catégorie introuvable
          </h1>

          <p className="mt-4 text-gray-600">
            Cette catégorie n'existe pas.
          </p>

          <Link
            to="/categories"
            className="inline-flex mt-8 px-6 py-3 rounded-xl bg-gray-900 text-white hover:bg-black transition"
          >
            Retour aux catégories
          </Link>

        </div>
      </section>
    )
  }

  const categoryProducts = products.filter(
    (product) => product.category === category.slug
  )

  return (
    <>
      <SEO
        title={category.name}
        description={
          category.description ||
          `Découvrez nos produits de la catégorie ${category.name}.`
        }
        keywords={`${category.name}, textile, mercerie, grossiste`}
        url={`https://www.khenissitextiles.com/categories/${category.slug}`}
      />

      <PageBanner
        title={category.name}
        subtitle={
          category.description ||
          `Découvrez notre sélection ${category.name}.`
        }
      />

      <section className="py-12 lg:py-16">
        <div className="container mx-auto px-4 lg:px-8">

          {/* Breadcrumb */}
          <div className="mb-8 text-sm text-gray-500">

            <Link
              to="/"
              className="hover:text-gray-900"
            >
              Accueil
            </Link>

            {" / "}

            <Link
              to="/categories"
              className="hover:text-gray-900"
            >
              Catégories
            </Link>

            {" / "}

            <span className="text-gray-900">
              {category.name}
            </span>

          </div>

          {/* Infos */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-10">

            <h2 className="text-3xl font-bold text-gray-900">
              {category.name}
            </h2>

            <p className="text-gray-500">
              {categoryProducts.length} produit
              {categoryProducts.length > 1 ? "s" : ""}
            </p>

          </div>

          {/* Produits */}
          {categoryProducts.length > 0 ? (
            <ProductGrid
              products={categoryProducts}
            />
          ) : (
            <div className="py-20 text-center">

              <h3 className="text-2xl font-bold text-gray-900">
                Aucun produit disponible
              </h3>

              <p className="mt-4 text-gray-600">
                Les produits de cette catégorie
                seront bientôt ajoutés.
              </p>

            </div>
          )}

        </div>
      </section>
    </>
  )
}